import {Weekday} from "@/pages/maintenance/maintenance-create/tabs/general/MaintenanceScheduleGeneralTab.types.ts";

export const WeekdayShort: Record<Weekday, string> = {
  [Weekday.MONDAY]: "M",
  [Weekday.TUESDAY]: "T",
  [Weekday.WEDNESDAY]: "W",
  [Weekday.THURSDAY]: "T",
  [Weekday.FRIDAY]: "F",
  [Weekday.SATURDAY]: "S",
  [Weekday.SUNDAY]: "S",
};
